var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"gal"},_vm._l((_vm.pics),function(pic,index){return _c('img',{key:index,attrs:{"src":pic,"alt":""}})}))}
var staticRenderFns = []

export { render, staticRenderFns }